module.exports = __webpack_public_path__ + "static/media/promo_matcha.7a1ae99a.jpg";